<div class="main-container animated fadeInRight">
  <div class="col-12">

    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="card border-success">
        <div class="card-header">
          <strong>Confirmación</strong>
        </div>
        <div class="card-body">
          <!-- (keyup)="onKeydown($event)" -->
          <div class="row col-12">
            <div class="form-group col-md-8" *ngIf="!activated" >
              
            </div>
            <div class="form-group col-md-4" *ngIf="activated" >
              <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'"
                  [idOpcion]="'clave'" [comboBox]="cmbArea" formControlName="idArea" (change)="selecionarArea()"
                  [control]="formulario.get('idArea')" [label]="'Area'" [id]="'idArea'">
              </app-lfsa-combo-box>
            </div>
            <div class="form-group col-md-4" *ngIf="activated" >
              <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'priDes'"
                  [idOpcion]="'priIP'" [comboBox]="cmbPuerta" formControlName="idPuerta" (change)="selecionarPuerta()"
                  [control]="formulario.get('idPuerta')" [label]="'Puerta'" [id]="'idPuerta'">
              </app-lfsa-combo-box>
            </div>
            <div class="form-group col-md-1">

            </div>
            <div class="form-group col-md-1">
              <label>&nbsp;</label>
              <label>&nbsp;</label>
              <label>&nbsp;</label>
              <label>&nbsp;</label>
              <br>
              <label>Marcación</label>
            </div>
            <div class="form-group col-md-2">
              <label>&nbsp;</label>
              <br>
              <label>&nbsp;</label>
              <div class="switchBtn">
                  <label>
                      <input id="termsCond" type="checkbox"
                          (click)="checkAccionTerminos()">
                      <span class="slide round">{{ opcionTermCond }}</span>
                  </label>
              </div>
            </div>
          <div class="row col-12">
            <div class="form-group col-md-6">
              <app-lfsa-input [control]="formulario.get('cedula')" [placeholder]="'Cédula'" formControlName="cedula"
                [label]="'Cédula*'" [type]="'numer'" [id]="'cedula'">
              </app-lfsa-input>
            </div>
            <div class="form-group col-md-6">
              <label>&nbsp;</label>
              <button [disabled]="formulario.invalid" class="btn {{ estiloBtn }} btn-block btn-lg"
                (click)="enviarTarjeta('')">Enviar</button>

            </div>
          </div>

          </div>       
          <div class="row col-12" *ngIf="activated"> 
              <div class="form-group col-md-12">
                <h2 class="card-text {{ estilo }} align-items-center d-flex justify-content-center">CONTROL DE ACCESO - {{ horario.toUpperCase() }} {{ estadoHorario }}</h2>
              </div>         
          </div>
          <div class="row col-12" *ngIf="activated">
            <div class="form-group col-md-2">
              <label>&nbsp;</label>
              <button class="btn btn-primary btn-block btn-lg"
                (click)="ejecutarBoton('1')"><h2>F1</h2></button>
            </div>
            <div class="form-group col-md-2">
              <label>&nbsp;</label>
              <button class="btn btn-danger btn-block btn-lg"
                (click)="ejecutarBoton('2')"><h2>F2</h2></button>
            </div>
            <div class="form-group col-md-2">
              <label>&nbsp;</label>
              <button class="btn btn-success btn-block btn-lg"
                (click)="ejecutarBoton('3')"><h2>F3</h2></button>
            </div>
            <div class="form-group col-md-2">
              <label>&nbsp;</label>
              <button class="btn btn-warning btn-block btn-lg"
                (click)="ejecutarBoton('4')"><h2>F4</h2></button>
            </div>
            <div class="form-group col-md-4">
              <label>&nbsp;</label>
              <button class="btn btn-dark btn-block btn-lg"
                (click)="ejecutarBoton('5')"><h2>ACCESO</h2></button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="col-12">
      <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
      <div class="div" *ngIf="!loading">


        <div class="card text-center animated fadeInRight" *ngIf="Bloqueado">
          <div class="card-header">
            <h3 class="card-text letrasDanger">NO PUEDE ENTRAR A LA PLANTA - {{ status.toUpperCase() }} -
              {{ nombreColaborador }}</h3>
          </div>
          <div class="card-body" align='center'>
            <div class="row col-12">
              <div class="col-md-4">
                <!-- <img [src]="imagen"> -->
                <img [src]="imagen" style="width: 20rem;" alt="" align='center'>
              </div>
              <div class="col-md-6">
                <h5 class="card-title">ESTADO</h5>
                <h1>
                  <p class="card-text letrasDanger" align='center'>{{ mostrarMensaje }}</p>
                </h1>
              </div>
              <div class="col-md-2" *ngIf="mostrarDias">
                <h3 class="card-title">Días</h3>
                <h3>
                  <p class="card-text letrasDanger" align='center'>{{ msnDias }}</p>
                  <p class="card-text letrasDanger" align='center'>{{ msnDias_ }}</p>
                  <p class="card-text letrasDanger" align='center'>{{ msnDias__ }}</p>
                </h3>
              </div>
            </div>
          </div>
          <div class="card-footer text-muted">
            <h3 class="card-text letrasDanger">NO PUEDE ENTRAR A LA PLANTA</h3>
          </div>
        </div>

        <br>

        <div class="card text-center animated fadeInRight" *ngIf="desbloqueado">
          <div class="card-header">
            <h3>{{ ingresoPlant }} {{ nombreColaborador }}</h3>
          </div>
          <div class="card-body">
            <div class="row col-12">
              <div class="col-md-4">
                <img [src]="imagen" style="width: 20rem;" alt="" align='center'>
              </div>

              <div class="col-md-6">
                <h5 class="card-title">ESTADO</h5>
                <h1>
                  <p *ngIf="colorLetrasDanger == true" class="card-text letrasDanger" align='center'>{{ mostrarMensaje }}</p>
                  <p *ngIf="colorLetrasDanger == false" class="card-text letrasVerde" align='center'>{{ mostrarMensaje }}</p>
                </h1>
              </div>

              <div class="col-md-2" *ngIf="mostrarDias">
                <h3 class="card-title">Días</h3>
                <h3>
                  <p *ngIf="colorLetrasDanger == true" class="card-text letrasDanger" align='center'>{{ msnDias }}</p>
                  <p *ngIf="colorLetrasDanger == true" class="card-text letrasDanger" align='center'>{{ msnDias_ }}</p>
                  <p *ngIf="colorLetrasDanger == true" class="card-text letrasDanger" align='center'>{{ msnDias__ }}</p>

                  <p *ngIf="colorLetrasDanger == false" class="card-text letrasVerde" align='center'>{{ msnDias }}</p>
                  <p *ngIf="colorLetrasDanger == false" class="card-text letrasVerde" align='center'>{{ msnDias_ }}</p>
                  <p *ngIf="colorLetrasDanger == false" class="card-text letrasVerde" align='center'>{{ msnDias__ }}</p>
                </h3>
              </div>
            </div>
          </div>
          <div class="card-footer text-muted">
            <h3>{{ ingresoPlant }}</h3>
          </div>
        </div>




        <br><br>
      </div>
    </div>

  </div>
</div>